import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var getDD_RUM = function() {
    return getGlobalProperty("DD_RUM");
};
export var emitDatadogAction = function(name, context) {
    var _getDD_RUM_addAction, _getDD_RUM;
    (_getDD_RUM = getDD_RUM()) === null || _getDD_RUM === void 0 ? void 0 : (_getDD_RUM_addAction = _getDD_RUM.addAction) === null || _getDD_RUM_addAction === void 0 ? void 0 : _getDD_RUM_addAction.call(_getDD_RUM, name, context);
};
export var emitDatadogError = function(error, context) {
    var _getDD_RUM_addError, _getDD_RUM;
    (_getDD_RUM = getDD_RUM()) === null || _getDD_RUM === void 0 ? void 0 : (_getDD_RUM_addError = _getDD_RUM.addError) === null || _getDD_RUM_addError === void 0 ? void 0 : _getDD_RUM_addError.call(_getDD_RUM, error, context);
};
export var emitDatadogTiming = function(name, time) {
    var _getDD_RUM_addTiming, _getDD_RUM;
    (_getDD_RUM = getDD_RUM()) === null || _getDD_RUM === void 0 ? void 0 : (_getDD_RUM_addTiming = _getDD_RUM.addTiming) === null || _getDD_RUM_addTiming === void 0 ? void 0 : _getDD_RUM_addTiming.call(_getDD_RUM, name, time);
};
